<template>
  <div class="page-aboutUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="../../assets/image/story_banner.png">
      <ul class="content">
        <li>
          <div class="title">
            <router-link to="/about/story">
              <p id="world">半个世纪的故事</p>
            </router-link>
          </div>
        </li>
        <li>
          <div class="title">
            <router-link to="/about/china">
              <p>爱在中国</p>
            </router-link>
          </div>
        </li>
        <li class="active">
          <div class="title">
            <p>KRK信念</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="belief-section">
      <div class="header w1200 clearfix">
        <div class="header-left">
          <div class="hr"></div>
          <h2>KRK信念</h2>
          <h3>Since 1961</h3>
        </div>
        <div class="header-right">Philosophy</div>
      </div>
      <div class="quote w1200">
        <div class="img1">
          <img src="../../assets/image/HugTeach.png">
        </div>
        <div class="img2">
          <h2>“拥抱让孩子获得安全和快乐，帮助他们更好地打开学习知识和探索世界的开关。”
            <br>
          </h2>
          <h3>——创始人Pat Vinson</h3>
        </div>
        <p>在孩子的一生发展中，婴幼儿时期建立起来的安全感和积极情绪至关重要。Kids 'R' Kids一直坚持的理念就是“Hug First, Then Teach（先拥抱，再启迪）”，我们致力于为孩子营造一个安全友爱的环境，让孩子在安心舒适的氛围里学习和成长。</p>
      </div>
      <div class="p-div div1 w1200">
        <div class="left">
          <h2>拥抱是孩子安全感的来源</h2>
          <h3>HUG FIRST,THEN TEACH</h3>
          <div class="hr"></div>
          <p
            class="p"
          >安全感是每个人与生俱来的精神需求。经常性的拥抱，亲密肢体接触，会让孩子感受到爱，从而获得安全感。著名的哈洛恒河猴实验论证了，与喂食相比，身体的舒适接触对依恋的形成有更重要的作用。当我们给孩子拥抱时，他们会体会到前所未有的美好感受，更容易放松和情绪愉快。
            <br>
            <br>Kids 'R' Kids所坚持的理念“Hug First, Then Teach（先拥抱，再启迪）”，是通过拥抱给予孩子最大程度的安全感，在这样充满安全感的环境中，孩子的归属感和依恋感得到最大程度上的满足，而这种满足则为孩子接下来的学习奠定了一个稳定的基础。
          </p>
        </div>
        <div class="right bg1">
          <div class="bg"></div>
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/hug/Phi_img1.jpg">
        </div>
      </div>
      <div class="p-div2">
        <div class="w1200">
          <div class="left bg2">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/hug/Phi_img2.jpg">
          </div>
          <div class="right bg1">
            <h2>拥抱，能帮助孩子完善人格</h2>
            <h3>HUG FIRST,THEN TEACH</h3>
            <div class="hr"></div>
            <p>研究表明：常被人拥抱和亲吻的婴孩，比那些长期没有亲密肢体接触的孩子更容易发展健全的感情生活。经常性地拥抱，让孩子有了安全感，在此基础上才能逐渐形成坚强、自信等良好的个性品质，成为一个对人友善、乐意探索、具有处事能力的人。
              <br>Kids 'R' Kids坚持的“Hug First, Then Teach（先拥抱，再启迪）”不仅是一种以大爱之心坚守的教育态度，也是一种经过超过半个世纪检验、用事实论证更有利于孩子人格发展的教育方式。更多地拥抱，可以帮助孩子在安全感形成的前提下，有效提升孩子的专注力、求知欲和情绪控制能力，拥有超越同龄人的优秀社交能力。
            </p>
          </div>
        </div>
      </div>
      <div class="p-div div3 w1200">
        <div class="left">
          <h2>拥抱，让老师和孩子成为爱之传播大使</h2>
          <h3>HUG FIRST,THEN TEACH</h3>
          <div id="hr"></div>
          <p
            class="p"
          >Kids 'R' Kids让“拥抱”成为一种企业文化，拥有一个家庭般的友爱氛围。KRK的老师和孩子都是KRK爱之文化的传播大使。我们给老师更多的爱和拥抱，关注他们的生命成长，老师们也会把更多的爱通过拥抱，传递给孩子。我们同时鼓励孩子将拥抱带给家人，让爱的表达成为一种习惯。</p>
        </div>
        <div class="right bg1">
          <div class="bg"></div>
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/hug/Phi_img3.jpg">
        </div>
      </div>
    </div>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>


<script>
import Header from "@/components/header/Header"; //悬浮头部
import Footer from "@/components/footer/footer"; //底部模块

export default {
  data() {
    return {};
  },
  components: {
    Header,
    "v-footer": Footer
  },
  mounted() {},
  methods: {}
};
</script>


<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-aboutUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          #world {
            width: 236px;
            height: 68px;
          }
          p {
            width: 163px;
            height: 68px;
            font-size: 24px;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
  .belief-section {
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .w1200 {
      width: 1200px !important;
      margin: 0 auto;
    }
    .header {
      width: 1200px;
      overflow: hidden;
      margin-top: 85px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 375px;
          height: 96px;
          font-size: 48px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 96px;
        }
        h3 {
          width: 142px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: left;
        margin-top: 16px;
        margin-left: 475px;
        height: 73px;
        font-size: 73px;
        font-family: TimesNewRomanPS-ItalicMT;
        font-style: italic;
        font-weight: normal;
        color: rgba(204, 204, 204, 1);
        line-height: 73px;
        text-align: left;
      }
    }
    .quote {
      height: 436px;
      margin-top: 8px;
      margin-bottom: 38px;
      .img1 {
        display: inline-block;
        margin-top: 84px;
        width: 390px;
        height: 117px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .img2 {
        display: inline-block;
        margin-left: 409px;
        width: 384px;
        height: 238px;
        background: url("../../assets/image/Phi_kuang.png") no-repeat;
        background-size: cover;
        h2,
        h3 {
          padding-top: 79px;
          padding-left: 34px;
          width: 315px;
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          text-align: left;
        }
        h3 {
          text-align: right;
          padding-top: 35px;
        }
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
        height: 198px;
        margin-top: 38px;
      }
    }
    .p-div {
      clear: both;
      height: 417px;
      padding-bottom: 126px;
      .left {
        float: left;
        width: 770px;
        h2 {
          height: 29px;
          line-height: 32px;
          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
        h3 {
          height: 55px;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 55px;
        }
        .hr {
          width: 120px;
          height: 2px;
          background: rgba(186, 165, 111, 1);
        }
        p {
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          padding-top: 63px;
        }
      }
      .right {
        float: left;
        margin-left: 178px;
        .bg {
          width: 250px;
          height: 250px;
          position: relative;
          left: 102px;
          top: 0px;
          background-color: #ae954f;
        }
        img {
          position: relative;
          top: -214px;
          width: 316px;
          height: 381px;
        }
      }
    }
    .p-div.div1 {
      .right {
        height: 417px;
        width: 352px;
        margin-left: 77px;
        overflow: hidden;
      }
    }
    .p-div2 {
      clear: both;
      height: 400px;
      background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/hug/Phi_bg1.jpg")
        no-repeat;
      .w1200 {
        height: 480px;
        background: #fff;
        -moz-box-shadow: 1px 5px 35px rgba(200, 200, 200, 0.7); /* 老的 Firefox */
        box-shadow: 1px 5px 35px rgba(200, 200, 200, 0.7);
      }
      .left {
        float: left;
        width: 400px;
        height: 490px;
        margin-left: 66px;
        margin-top: 37px;

        img {
          width: 400px;
          height: 490px;
        }
      }
      .right {
        float: left;
        width: 597px;
        margin-left: 79px;
        margin-top: 39px;
        h2 {
          height: 29px;
          line-height: 32px;
          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
        h3 {
          height: 55px;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 55px;
        }
        .hr {
          width: 120px;
          height: 2px;
          background: rgba(186, 165, 111, 1);
        }
        p {
          width: 590px;
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          padding-top: 63px;
        }
      }
    }
    .p-div.div3 {
      padding-top: 206px;
      padding-bottom: 73px;
      height: 344px;
      .left {
        width: 612px;
        p {
          width: 612px;
          padding-top: 63px;
        }
        #hr {
          width: 120px;
          height: 2px;
          background: rgba(186, 165, 111, 1);
        }
      }
      .right {
        width: 536px;
        height: 344px;
        margin-left: 51px;
        overflow: hidden;
        .bg {
          width: 250px;
          height: 250px;
          position: relative;
          left: 286px;
          top: 94px;
          background-color: #0e4082;
        }
        img {
          position: relative;
          width: 500px;
          height: 308px;
          top: -250px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page-aboutUs {
    .banner {
      padding-top: 45px;
      .content {
        width: 100%;
        position: absolute;
        left: 0;
        margin-left: 0;
        bottom: 0;
        height: 35px;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px;
            }
            p {
              width: auto;
              padding: 0 24px;
              height: 35px;
              font-size: 14px;
              line-height: 35px;
            }
          }
        }
      }
    }
    .belief-section {
      .w1200 {
        width: 100% !important;
      }
      .header {
        width: 100%;
        overflow: hidden;
        margin-top: 35px;
        .header-left {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.1%;
          .hr {
            width: 56px;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
          }
          h3 {
            width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
          }
        }
        .header-right {
          display: none;
        }
      }
      .quote {
        width: 100%;
        height: 190px;
        margin-top: 8px;
        margin-bottom: 32px;
        box-sizing: border-box;
        padding-left: 7.3%;
        .img1 {
          position: relative;
          right: -1%;
          top: -33px;
          display: inline-block;
          margin-top: 35px;
          width: 36.1%;
          height: auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img2 {
          position: relative;
          right: 2%;
          top: -82px;
          display: inline-block;
          margin-left: 0;
          width: 61%;
          height: 112px;
          background: url("../../assets/image/Phi_kuang.png") no-repeat;
          background-size: 100% 100%;

          h2,
          h3 {
            padding-top: 25px;
            padding-left: 10%;
            width: 80%;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            text-align: left;
          }
          h3 {
            text-align: right;
            padding-top: 0;
          }
        }
        p {
          position: relative;
          top: -57px;
          width: 100%;
          box-sizing: border-box;
          padding: 0;
          padding-right: 7.3%;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 21px;
          height: 109px;
          margin-top: 32px;
        }
      }
      .p-div {
        clear: both;
        height: 697px;
        padding-bottom: 64px;
        display: flex;
        flex-direction: column-reverse;
        .left {
          float: left;
          width: 100%;
          padding: 0 7.9%;
          box-sizing: border-box;
          h2 {
            height: 22px;
            line-height: 22px;
            font-size: 21px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 10px;
          }
          h3 {
            height: 22px;
            font-size: 12px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
            margin-bottom: 7px;
          }
          .hr {
            width: 16.4%;
          }
          p {
            width: 100%;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
            padding-top: 22px;
          }
        }
        .right {
          float: left;
          margin-left: 0;
          width: 100%;
          padding-left: 16.5%;
          padding-bottom: 30px;
          box-sizing: border-box;
          .bg {
            width: 50%;
            height: 156px;
            position: relative;
            left: 96px;
            top: 6px;
            background-color: #ae954f;
          }
          img {
            position: relative;
            top: -134px;
            width: 76%;
            height: auto;
          }
        }
      }
      .p-div.div1 {
        .right {
          height: auto;
          width: 100%;
          margin-left: 0;
          overflow: hidden;
        }
      }
      .p-div2 {
        width: 100%;
        clear: both;
        height: 202px;
        background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/hug/Phi_bg1.jpg")
          no-repeat;
        .w1200 {
          width: 100%;
          height: auto;
          -moz-box-shadow: none;
          box-shadow: none;
        }
        .left {
          width: 85%;
          height: 240px;
          margin: 0 7.5%;
          padding: 0 7.9%;
          padding-top: 15px;
          box-sizing: border-box;
          background: #fff;
          -moz-box-shadow: 1px 5px 35px rgba(200, 200, 200, 0.7); /* 老的 Firefox */
          box-shadow: 1px 5px 35px rgba(200, 200, 200, 0.7);
          img {
            width: 100%;
            height: auto;
          }
        }
        .right {
          float: left;
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.9%;
          margin-left: 0;
          margin-top: 127px;
          h2 {
            height: 22px;
            line-height: 22px;
            font-size: 21px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 10px;
          }
          h3 {
            height: 22px;
            font-size: 12px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
            margin-bottom: 7px;
          }
          .hr {
            width: 16.4%;
          }
          p {
            width: 100%;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
            padding-top: 22px;
          }
        }
      }
      .p-div.div3 {
        padding-top: 57px;
        padding-bottom: 30px;
        width: 100%;
        height: 480px;
        display: flex;
        flex-direction: column-reverse;
        .left {
          width: 100%;
          h2 {
            font-size: 18px;
          }
          p {
            width: 100%;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
            padding-top: 22px;
          }
          #hr {
            width: 16.4%;
          }
        }
        .right {
          float: left;
          margin-left: 0;
          width: 100%;
          padding: 0 11.7% 30px 7.7%;
          box-sizing: border-box;
          .bg {
            width: 50%;
            height: 146px;
            position: relative;
            left: 54.4%;
            top: 68px;
            background-color: #0e4082;
          }
          img {
            position: relative;
            top: -134px;
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .page-aboutUs {
    .belief-section {
      .p-div.div1 {
        height: 683px;
        .left {
          p {
            height: 230px;
          }
          h2 {
            height: 30px;
          }
        }
        .right {
          .bg {
            height: 190px;
            left: 106px;
            top: 0px;
          }
          img {
            top: -174px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .right {
          margin-top: 160px;
        }
      }
      .p-div.div3 {
        height: 480px;
        .left {
          p {
            height: 110px;
          }
        }
        .right {
          .bg {
            height: 141px;
            left: 182px;
            top: 108px;
          }
          img {
            top: -112px;
            // left: 0;
          }
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .page-aboutUs {
    .belief-section {
      .quote {
        height: 215px;
        p {
          height: 124px;
        }
        .img2 {
          background-size: 100% 100%;
          h2 {
            padding-top: 28px;
          }
        }
      }
      .p-div.div1 {
        height: 695px;
        .left {
          p {
            height: 280px;
          }
          h2 {
            height: 30px;
          }
        }
        .right {
          .bg {
            height: 150px;
            left: 92px;
            top: -1px;
          }
          img {
            top: -135px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .right {
          margin-top: 115px;
        }
      }
      .p-div.div3 {
        height: 495px;
        .left {
          p {
            height: 160px;
          }
          h2 {
            height: 44px;
          }
        }
        .right {
          .bg {
            height: 121px;
            left: 160px;
            top: 82px;
          }
          img {
            top: -112px;
            left: 0;
          }
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .page-aboutUs {
    .belief-section {
      .quote {
        height: 215px;
        p {
          height: 124px;
        }
        .img2 {
          background-size: cover;
          h2 {
            padding-top: 18px;
          }
        }
      }
      .p-div.div1 {
        height: 682px;
        .left {
          p {
            height: 300px;
          }
          h2 {
            height: 30px;
          }
        }
        .right {
          .bg {
            height: 135px;
            left: 83px;
            top: 0;
          }
          img {
            top: -121px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .right {
          margin-top: 85px;
        }
      }
      .p-div.div3 {
        height: 482px;
        .left {
          p {
            height: 160px;
          }
          h2 {
            height: 44px;
          }
        }
        .right {
          .bg {
            height: 105px;
            left: 146px;
            top: 82px;
          }
          img {
            top: -95px;
            left: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/belief.vue